/**
 * DarkChat - Modern karanlık temalı web tabanlı sohbet uygulaması
 * Ana uygulama modülü
 */

import { authService, userService } from './services/firebase.js';
import { initAuthForm } from './components/AuthForm.js';
import { initUserProfile } from './components/UserProfile.js';
import { initChatList } from './components/ChatList.js';
import { initChatWindow } from './components/ChatWindow.js';
import '../css/styles.css';

class App {
  constructor() {
    this.currentUser = null;
    this.authForm = null;
    this.userProfile = null;
    this.chatList = null;
    this.chatWindow = null;
    
    this.authContainer = document.getElementById('auth-container');
    this.chatContainer = document.getElementById('chat-container');
    
    this.init();
  }
  
  init() {
    // Kimlik doğrulama durumunu dinle
    authService.onAuthStateChanged(async (user) => {
      if (user) {
        await this.handleUserSignedIn(user);
      } else {
        this.handleUserSignedOut();
      }
    });
    
    // Progressive enhancement
    this.setupServiceWorker();
    this.setupThemeToggle();
    this.setupMobileGestures();
  }
  
  async handleUserSignedIn(user) {
    this.currentUser = user;

    try {
      await userService.resumeSessionAfterAuth(user)
    } catch (err) {
      console.warn('Oturum senkronu başarısız:', err)
    }
    
    // Arayüzü güncelle
    this.authContainer.classList.add('hidden');
    this.chatContainer.classList.remove('hidden');
    
    // Kullanıcı profili, sohbet listesi ve sohbet penceresini başlat
    this.userProfile = initUserProfile(user);
    this.chatList = initChatList(user.uid);
    this.chatWindow = await initChatWindow(user);
  }
  
  handleUserSignedOut() {
    userService.stopPresenceTracking()
    this.currentUser = null;
    
    // Arayüzü güncelle
    this.authContainer.classList.remove('hidden');
    this.chatContainer.classList.add('hidden');
    
    // Auth formunu başlat
    this.authForm = initAuthForm();
    
    // Diğer bileşenleri temizle
    this.userProfile = null;
    this.chatList = null;
    this.chatWindow = null;
  }
  
  async setupServiceWorker() {
    // Service Worker desteği var mı kontrol et
    if ('serviceWorker' in navigator) {
      try {
        // Daha sonra geliştirilecek
        // const registration = await navigator.serviceWorker.register('/service-worker.js');
        // //console.log('Service Worker başarıyla kaydedildi:', registration);
      } catch (error) {
        //console.error('Service Worker kaydı başarısız:', error);
      }
    }
  }
  
  setupThemeToggle() {
    // Tema tercihi varsa uygula
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'light') {
      document.documentElement.setAttribute('data-theme', 'light');
    }
    
    // Tema değiştirme fonksiyonu
    window.toggleTheme = () => {
      const currentTheme = document.documentElement.getAttribute('data-theme');
      const newTheme = currentTheme === 'light' ? null : 'light';
      
      if (newTheme) {
        document.documentElement.setAttribute('data-theme', newTheme);
        localStorage.setItem('theme', newTheme);
      } else {
        document.documentElement.removeAttribute('data-theme');
        localStorage.removeItem('theme');
      }
    };
  }
  
  setupMobileGestures() {
    // Mobil swipe gesture'ları için
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    
    const minSwipeDistance = 50; // Minimum swipe mesafesi (px)
    const maxVerticalDistance = 100; // Maksimum dikey sapma
    
    document.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });
    
    document.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      
      const horizontalDistance = touchEndX - touchStartX;
      const verticalDistance = Math.abs(touchEndY - touchStartY);
      
      // Yatay swipe ve dikey sapma küçükse
      if (Math.abs(horizontalDistance) > minSwipeDistance && verticalDistance < maxVerticalDistance) {
        const sidebar = document.querySelector('.sidebar');
        
        if (sidebar) {
          // Sağa swipe - sidebar'ı aç
          if (horizontalDistance > 0 && touchStartX < 30) {
            sidebar.classList.add('open');
          }
          // Sola swipe - sidebar'ı kapat
          else if (horizontalDistance < 0 && sidebar.classList.contains('open')) {
            sidebar.classList.remove('open');
          }
        }
      }
    }, { passive: true });
    
    // Sidebar dışına tıklanınca kapat (mobilde)
    document.addEventListener('click', (e) => {
      const sidebar = document.querySelector('.sidebar');
      const isMobile = window.innerWidth <= 768;
      
      if (isMobile && sidebar && sidebar.classList.contains('open')) {
        // Sidebar'a tıklanmadıysa kapat
        if (!sidebar.contains(e.target) && !e.target.closest('.mobile-menu-button')) {
          sidebar.classList.remove('open');
        }
      }
    });
    
    // Keyboard açıldığında layout'u düzelt (mobil)
    let originalHeight = window.innerHeight;
    
    window.addEventListener('resize', () => {
      const currentHeight = window.innerHeight;
      const heightDiff = originalHeight - currentHeight;
      
      // Keyboard açıldıysa (ekran yüksekliği önemli ölçüde azaldıysa)
      if (heightDiff > 150) {
        document.body.classList.add('keyboard-open');
      } else {
        document.body.classList.remove('keyboard-open');
        originalHeight = currentHeight;
      }
    });
  }
}

// Uygulamayı başlat
window.addEventListener('DOMContentLoaded', () => {
  window.app = new App();
}); 